import { memo } from 'react';
import { Row, Col, Container } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { BzCard, BzChip } from "../../components";
import { StatusChip } from '../Orders';
import { ALL_ORDERS_STATUS, LOCATIONS, MARKET_SEGMENT_ID, ORDERS_TABKEY, ORDER_TYPES, SESSION_STORAGE_KEYS, } from '../../utils/global_variables';
import ZeroStates from '../ZeroStates';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getScripOrderInfo } from '../../redux/actions/orders';
import { isUserIsAGuest,setStorageWithMultiTabCheckWithoutEncryption} from '../../utils/global_functions';


const OpenOrderSip = () => {

    const location = useLocation();
    const dispatch = useDispatch();
    const getSipOrder = useSelector(state => state.orders.orderTypes[2].data);
    const getSIPOpenOrder = getSipOrder?.filter((each) => each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING || each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_ACTIVE || each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_RUNNING);

    const handlePlaceOrder = () => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
            dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.EQUITY_SIP } }));
            const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
            dispatch(getScripOrderInfo(objScrpinfo));
        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    };

    const navigate = useNavigate();

    const handleOrderHistory = (id) => {
        let path = `/orders?section=${ORDER_TYPES.EQUITY_SIP}&ordertype=${ORDERS_TABKEY.OPEN_ORDERS}`;
        navigate(path, { state: id });
        setStorageWithMultiTabCheckWithoutEncryption(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };


    return (
        <>

            {
                location.pathname === LOCATIONS.WATCHLIST ?
                    <Container fluid className='p-0 px-2 mt-3 horizontal-scroll-wrap'>
                        {getSipOrder?.length > 0 ?//BT-113272 Watchlist, Sidetray, Order book - UI changes : ManasaB : 13/07/2023
                            <Row className='g-0' >
                                <Col className='p-0'>
                                    <div className='transparent-card-wrap'>
                                        {getSipOrder?.map((each, i) => (
                                            <div key={i} className='transparent-card cursor-pointer bdr-btm'>
                                                <Row className='g-0 mb-2'>
                                                    <Col md={8} className='justify-content-start align-self-center'>
                                                        <div className='font-medium font-size3 color-text float-start'>{each?.symbol}</div>
                                                        {/* <div className='font-regular font-size2 color-subtext'>{each.expiryDate} {each.strikePrice} {each.contractType}</div> */}
                                                    </Col>
                                                    <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                        <StatusChip isSipStatusChip={true} data={each} />
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mb-2'>
                                                    <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                        <div className='chips-wrap'>
                                                            <BzChip className='exchange-chip me-2'>{each?.exchange.split('_')[0]}</BzChip>
                                                        </div>
                                                        <div className='font-regular font-size2 color-subtext'>{each?.series} </div>
                                                    </Col>
                                                    <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                        <div className='font-regular font-size3 color-subtext'>
                                                            <span className='font-medium font-size2 color-text'>Installment:{each?.executed_installments}/{each?.no_of_installments}</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mb-2'>
                                                    <Col md={6} className='chips-wrap'>
                                                        <div className='d-flex justify-content-start align-self-center'>
                                                            <div className='d-flex align-self-center font-regular font-size1 color-subtext me-2'>{each?.frequency_details}</div>
                                                            <div className='chips-wrap'>
                                                                <BzChip className='chips primary-chip text-capitalize'>EQ SIP</BzChip>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                        <div className='font-regular font-size3 color-text'>
                                                            <span className={`font-medium color - text ${each?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'} `}>{each?.transaction_type}:</span>  {each?.invested_qty_or_val} {`${each?.investment_value > 0 ? 'Value' : 'Qty'}`}  @ Market
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                            :
                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                <ZeroStates handleOnClick={handlePlaceOrder} subText="You are yet to place an order" icon='icon-64 icon-nodata mb-3 mrgauto' btnText="Place an order now" btnClass="btn btn-block btn-outline mt-2" />
                            </div>
                        }
                    </Container>
                    :
                    (
                        location.pathname === LOCATIONS.DASHBOARD ?
                            <Container fluid className='p-0 pe-2'>
                                {
                                    getSipOrder?.length > 0 ?
                                        <Row className='g-0'>
                                            <Col className='p-0'>
                                                <div className='transparent-card-wrap'>
                                                    {getSIPOpenOrder?.map((each, i) => (
                                                        <BzCard key={i} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleOrderHistory(each?.sip_id)}>
                                                            <Row className='g-0 mb-2'>
                                                                <Col md={8} className='justify-content-start align-self-center'>
                                                                    <div className='font-medium font-size3 color-text'>{each?.symbol}</div>
                                                                </Col>
                                                                <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='orderstatus-chips-wrap'>
                                                                        <StatusChip isSipStatusChip={true} data={each} />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mb-2'>
                                                                <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                                    <div className='chips-wrap'>
                                                                        <BzChip className='exchange-chip me-2'>{each?.exchange.split('_')[0]}</BzChip>
                                                                    </div>
                                                                    <div className='font-regular font-size2 color-subtext'>{each?.series}</div>
                                                                </Col>
                                                                <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='font-regular font-size3 color-subtext'>
                                                                        <span className='font-medium font-size2 color-text'>Installment: {each?.executed_installments}/{each?.no_of_installments}</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mb-2'>
                                                                <Col md={6}>
                                                                    <div className='d-flex justify-content-start align-items-center'>
                                                                        <Row className='g-0'>
                                                                            <Col>
                                                                                <div className='font-regular font-size1 color-subtext'>{each?.frequency_details}</div>
                                                                            </Col>
                                                                            <Col md="auto" className='ms-2'>
                                                                                <div className='chips-wrap'>
                                                                                    <BzChip className='chips primary-chip text-capitalize'>EQ SIP</BzChip>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Col>
                                                                <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='font-regular font-size3 color-text'>
                                                                        <span className={`font - medium color - text ${each?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'} `}>{each?.transaction_type}:</span> {each?.invested_qty_or_val} {`${each?.investment_value > 0 ? 'Value' : 'Qty'}`}@ Market
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </BzCard>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>
                                        :
                                        <div className='zero-state-alerts zero-state-alerts-md'>
                                            <ZeroStates handleOnClick={handlePlaceOrder} subText="You are yet to place an order" icon='icon-64 icon-nodata mb-3 mrgauto' btnText="Place an order now" btnClass="btn btn-md btn-outline mt-2" />
                                        </div>
                                }
                            </Container>
                            : null
                    )
            }
        </>


    );
};

export default memo(OpenOrderSip);